import { Sidebar } from "@components:Sidebar/Sidebar";
import { useRBACCheck } from "@hooks:useRBAC";
import { IconButton } from "@mui/material";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { FaUsers } from "react-icons/fa6";
import { MdAccountCircle, MdDomain, MdKeyboardArrowLeft } from "react-icons/md";
import { RiRobot2Fill } from "react-icons/ri";
import { useLocation, useNavigate } from "react-router";

import { DEFAULT_ROUTE_AFTER_LOGIN, Routes } from "@:constants";
import { RBACAction, RBACResource } from "@:rbac";

export const SettingsSidebar = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const canAccessProfile = useRBACCheck(
    RBACAction.read,
    RBACResource["settings__profile"],
  );
  const canAccessOrganizations = useRBACCheck(
    RBACAction.read,
    RBACResource["settings__organizations"],
  );
  const canAccessUsers = useRBACCheck(
    RBACAction.read,
    RBACResource["settings__users"],
  );
  const canAccessBots = useRBACCheck(
    RBACAction.read,
    RBACResource["settings__bots"],
  );

  return (
    <Sidebar
      sx={{
        mx: "10px",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          position: "relative",
        }}
        className="SettingsSidebar__Header"
      >
        <IconButton
          sx={{
            position: "absolute",
            left: "0",
          }}
          onClick={() => {
            navigate(DEFAULT_ROUTE_AFTER_LOGIN);
          }}
        >
          <MdKeyboardArrowLeft />
        </IconButton>

        <Typography fontSize={"30px"}>Settings</Typography>
      </Box>

      <Sidebar.Menu
        subHeading="MY ACCOUNT"
        sx={{
          marginTop: "50px",
        }}
        hidden={!canAccessProfile}
      >
        <Sidebar.MenuItem
          icon={<MdAccountCircle />}
          onClick={() => {
            navigate(Routes.SettingsProfile);
          }}
          selected={pathname === Routes.SettingsProfile}
          hidden={!canAccessProfile}
        >
          Profile
        </Sidebar.MenuItem>
      </Sidebar.Menu>

      <Sidebar.Menu
        subHeading="TENANT"
        sx={{
          marginTop: "20px",
        }}
        hidden={!canAccessOrganizations && !canAccessUsers && !canAccessBots}
      >
        <Sidebar.MenuItem
          icon={<MdDomain />}
          onClick={() => {
            navigate(Routes.SettingsOrganizations);
          }}
          selected={pathname === Routes.SettingsOrganizations}
          hidden={!canAccessOrganizations}
        >
          Organizations
        </Sidebar.MenuItem>

        <Sidebar.MenuItem
          icon={<FaUsers />}
          onClick={() => {
            navigate(Routes.SettingsUsers);
          }}
          selected={pathname === Routes.SettingsUsers}
          hidden={!canAccessUsers}
        >
          Users
        </Sidebar.MenuItem>

        <Sidebar.MenuItem
          icon={<RiRobot2Fill />}
          onClick={() => {
            navigate(Routes.SettingsBots);
          }}
          selected={pathname === Routes.SettingsBots}
          hidden={!canAccessBots}
        >
          Bots
        </Sidebar.MenuItem>
      </Sidebar.Menu>
    </Sidebar>
  );
};
